module.exports = __webpack_public_path__ + "static/img/catcher.572cac0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/catcher.png
// module id = 315
// module chunks = 9